import { BaseUserSchema, MeSchema } from "../../api/schemas/responses/users";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import authUserStore from "../../modules/auth/store";
import { useApiCall } from "../../hooks/useApiCall";
import { API } from "../../api/api";
import { Autocomplete } from "@mui/material";
import Box from "@mui/material/Box";
import UserPreview from "../UsersPreview/UserPreview";
import TextField from "@mui/material/TextField";
import i18nStore from "../../i18n/store";


export interface UserSelectorProps {
    user: BaseUserSchema | null;
    setUser: (param: BaseUserSchema | null) => void;
}

const UserSelector = observer((props: UserSelectorProps) => {
    const translations = i18nStore.getTranslations;
    const [users, setUsers] = useState<BaseUserSchema[]>([]);
    const [userName, setUserName] = useState<string>("");
    const me: MeSchema | undefined = authUserStore.getMe;

    const filterUserApi = useApiCall<BaseUserSchema[]>(
        () => API.users.findByName(userName).then(users => {
            setUsers(users.filter(user => user.id !== me?.id));
            return users;
        }),
        [],
    );
    useEffect(() => {
        if (userName && userName.length >= 2) {
            filterUserApi.apiCaller();
        }
    }, [userName]);
    return (
        <>
            <Autocomplete
                options={users}
                size="small"
                loading={filterUserApi.loading}
                fullWidth
                freeSolo={false}
                noOptionsText={translations.noUsersFound}
                includeInputInList
                // @ts-ignore
                getOptionLabel={(user: BaseUserSchema) => user ? user.name || "" : ""}
                renderOption={(props, option) => {
                    return (
                        <Box
                            component="li"
                            {...props}
                            key={option.id}
                            sx={{
                                display: "flex",
                                width: "100%",
                                background: "#fff",
                                "&:hover": {
                                    cursor: "pointer",
                                },
                            }}
                        >
                            <UserPreview user={option} />
                        </Box>
                    );
                }}
                onChange={(event: any, newValue: BaseUserSchema | null) => {
                    props.setUser(newValue);
                }}
                onInputChange={(event: any, newInputValue: string) => {
                    setUserName(newInputValue);
                }}
                renderInput={(params: any) => (
                    <TextField {...params} fullWidth />
                )}
            />
        </>
    );
});

export default UserSelector;
